import type { AttributeCategory } from '@/modules/accounting/features/transactions/types/mockup-utils.types'

/**
 * Classify an attribute's direction from its requires-incoming/outgoing flags.
 * Single source of truth for the deposit (`positive`) / withdrawal (`negative`)
 * / `operator` rule — derived purely from the DB catalog columns.
 */
export function classifyAttributeDirection(
  requiresIncoming: boolean,
  requiresOutgoing: boolean,
): AttributeCategory {
  if (requiresIncoming && !requiresOutgoing) return 'positive'
  if (requiresOutgoing && !requiresIncoming) return 'negative'
  return 'operator'
}
